export default __webpack_public_path__ + "static/media/logoLabel.053a429d.png";